import { useForm } from "react-hook-form";
import { Stack, Typography, useTheme } from "@mui/material";

import { FormProvider } from "@app/components";
import { Strings } from "@app/constants";
import { Section1 } from "./section1";
import { Section2 } from "./section2";
import { Section3 } from "./section3";
import { Section4 } from "./section4";

const CarInfo = ({ methods }: any) => {
  const theme = useTheme();

  return (
    <>
      <Stack flexDirection={"column"} py={2}>
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {Strings.step.carInfo.tellUsAboutYourCar}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.grey[500], textAlign: "center" }}
          >
            {Strings.step.carInfo.fillInYourCarsDetails}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        flexDirection={"row"}
        gap={2}
        flexWrap={"wrap"}
        mb={2}
        justifyContent={"center"}
        alignItems="stretch"
      >
        <Section1 methods={methods} />
        <Section2 methods={methods} />
        <Section3 methods={methods} />
        <Section4 methods={methods} />
      </Stack>
      {methods.formState.errors?.carInfo && (
        <Typography color="error" textAlign="center" mt={2}>
          Please fill car details properly
        </Typography>
      )}
    </>
  );
};

export { CarInfo };
